import { shortFormatNumber } from '../../util'
import { FinancialsRowDataType } from '../financials-table/types'
import { ChartData, View } from './types'

export function tickFormatter(value: any) {
  return shortFormatNumber(value, { fractions: 0 })
}

export function getChartDataItemKey(item: Pick<FinancialsRowDataType, 'id' | 'label'>) {
  return item.id || item.label
}

export function getChartData(data: FinancialsRowDataType[], yearKeys: string[], chartView: View) {
  /*
   * Bar chart renders segments from the bottom up, so the sorting of visible areas is correct here
   * assuming it's sorted by column values
   * */
  const visibleAreas = data.filter((item) => item.isSelected).map((item) => ({ ...item, color: item.color }))
  /*
   * Line chart has reverse order because we need to render lines from the end so they don't cover main lines
   * you can think about it as visibleAreas index === zIndex on the chart
   * */
  if (chartView === View.lines) visibleAreas.reverse()

  const chartData = yearKeys.map((year) => {
    const stackedBar = { year, topKey: '', bottomKey: '', total: 0 } as ChartData

    visibleAreas.forEach((item) => {
      const valueKey = getChartDataItemKey(item)
      const value = item.values.find((v) => v.year === year)?.value ?? null
      stackedBar[valueKey] = value
      stackedBar.total += value ?? 0

      if (item.isSelected && value !== 0) {
        // top key is the key of latest area which is visible and have some positive value
        // bottom key is the key of latest area which is visible and have some negative value
        stackedBar[value && value > 0 ? 'topKey' : 'bottomKey'] = valueKey
      }
    })

    return stackedBar
  })

  return { chartData, visibleAreas }
}
